import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { removeLanguageFromPath } from "./languageCore";

/**
 * Component that handles fallback redirects for invalid language routes
 * If a user hits a language-prefixed route that doesn't exist (e.g., /fr/profile),
 * this component will redirect them to the non-language version (e.g., /profile)
 */
const LanguageFallbackRedirect: React.FC = () => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    // Remove the language prefix from the current path
    const pathWithoutLanguage = removeLanguageFromPath(location.pathname);

    // Preserve query string and hash
    const search = location.search || "";
    const hash = location.hash || "";

    // Redirect to the path without language prefix
    const redirectPath = `${pathWithoutLanguage}${search}${hash}`;

    // Use replace to avoid adding to browser history
    history.replace(redirectPath);
  }, [history, location]);

  // Return null while redirecting
  return null;
};

export default LanguageFallbackRedirect;
